'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var BlogAccesslog;
(function (BlogAccesslog) {
    var MyBlogAccesslog = /** @class */ (function () {
        function MyBlogAccesslog(ajaxing) {
            if (ajaxing === void 0) { ajaxing = false; }
            this.ajaxing = ajaxing;
            var self = this;
            if ($('#paramThisIsBlogDetailPage').length > 0) {
                this.init();
                var accesslog = window.setInterval(function () {
                    self.ajaxUpdateElapsedSeconds();
                }, self.intervalSeconds * 1000);
            }
            ;
        }
        MyBlogAccesslog.prototype.init = function () {
            this.accessId = $('#paramAccessId').val();
            this.intervalSeconds = Number($('#paramIntervalSeconds').val());
        };
        MyBlogAccesslog.prototype.ajaxUpdateElapsedSeconds = function () {
            var self = this;
            self.ajaxing = true;
            var token = $('meta[name="csrf-token"]').attr('content');
            var D = { accessId: this.accessId, intervalSeconds: this.intervalSeconds };
            $.ajax({
                headers: { 'X-CSRF-TOKEN': token },
                url: '/ajax/blog/update_elapsed_seconds',
                type: 'post',
                data: D,
                dataType: 'json',
                success: function (data) {
                    console.log(data.elapsed_seconds);
                }
            });
        };
        return MyBlogAccesslog;
    }());
    BlogAccesslog.MyBlogAccesslog = MyBlogAccesslog;
})(BlogAccesslog || (BlogAccesslog = {}));
exports.default = BlogAccesslog;
